import {SCALE} from 'actions'

const reducer = (state = {}, {type, scale}) => {
  if (type === SCALE) {
    return scale
  }
  return state
}

export default reducer
